<template>
    <div id="credit_memo_log">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Credit Memo Data Log</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
                    <div class="web-action-btn btn-groups text-right">
                        <a v-if="canExport" href="javascript:void(0)" class="btn btn-secondary"
                            v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="from-group">
                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <strong id="errorMsg" class="field-error"></strong>
                        </div>
                    </div>
                    <div class="admin-page-content gallery-list">
                        <data-table-filter-config :moduleName="'creditMemoLogList'" :removeLineButtonVisibility="true"
                            :addFilterButtonVisibility="true" @cancelSelection="cancelAll"
                            :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in
                            process.
                            batch no. is {{ batchNum }}.
                            <router-link class="color-blue" v-bind:to="{ name: 'BatchList' }" target="_blank"
                                @click.native="batchProcess = 0"> Click Here
                            </router-link>
                            to check file status!
                        </p>
                        <section class="data-table bg-white">
                            <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange"
                                :moduleName="'creditMemoLogList'" :position="'top'">
                            </custom-pagination>
                            <vue-good-table ref="creditMemoLogList" mode="remote" title="Credit Memo Data Log"
                                @on-page-change="onPageChange" @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange"
                                :totalRows="totalRecords" :columns="userColumns" :rows="rows" :pagination-options="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    perPageDropdown: dropDownPerPage,
                                    dropdownAllowAll: false,
                                }" :select-options="{
                                    enabled: false,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                }" :search-options="{
                                    enabled: false,
                                }">

                                <template slot="table-row" slot-scope="props" v-for="(row, key) in rows">
                                    <div :key="key">
                                        <div v-if="props.column.field == 'action'">
                                            <a style="cursor: pointer;color: var(--secondary-font-color);"
                                                v-if="canEditCreditMemoLog" @click="showEditModal(props.row)"
                                                title="Edit Credit Memo Log"><i class="fp-edit"></i></a>
                                            <a v-if="canViewAuditLog" title="View Audit Log"
                                                v-on:click.prevent="goToGetLogInfo(props.row.ev_claim_header_id)"
                                                class="fp-log-file-format" href="javascript:void(0)"></a>
                                        </div>
                                        <div v-else-if="props.column.field == 'cm_number'">
                                            <a class="color-blue" v-on:click="goToGetDocumentPath($event, props.row)"
                                                title="View Credit Memo Document" href="" style="font-size: 15px;">
                                                {{ props.formattedRow[props.column.field] }}
                                            </a>
                                        </div>
                                        <div class="text-right" v-else-if="props.column.field == 'cm_grand_total'">
                                            ${{ props.formattedRow[props.column.field] }}
                                        </div>
                                        <div v-else>
                                            {{ props.formattedRow[props.column.field] }}
                                        </div>
                                    </div>
                                </template>
                            </vue-good-table>
                            <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>
                    </div>
                </div>
                <div class="modal fade" id="editCreditMemoLog" tabindex="-1" role="dialog" data-backdrop="static">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div style="display: flex; justify-content: center; align-items: center;" class="mt-4 mb-3">
                                <img :src="logoPath" alt="Dealer Pro" style="height: 70px; margin-right: 7px">
                            </div>
                            <div class="pl-5 pr-5 mt-1">
                                <div class="form-row">
                                    <div class="col-12 form-group">
                                        <label class="control-label require" for="submitted-to-accounting">Submitted to
                                            Accounting?:</label>
                                        <v-select v-model="submittedToAccounting" name="submitted-to-accounting"
                                            placeholder="Select..." label="text"
                                            @change="submittedToAccountingChanged($event)" :options="['Yes', 'No']">
                                        </v-select>
                                        <span class="field-error" v-if="submittedToAccountingErrMsg">{{
                                            submittedToAccountingErrMsg }}</span>
                                    </div>
                                    <div class="col-12 form-group">
                                        <label class="control-label require" for="submitted-date">Submitted
                                            Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="submitted-date"
                                                name="submitted-date" v-model="submittedDate" :config="dateOptions"
                                                :disabled="true"></date-picker>
                                            <label for="submitted-date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ submittedDateErrMsg }}</div>
                                    </div>
                                    <div class="col-12 form-group">
                                        <label class="control-label require" for="submitted-by">Submitted By:</label>
                                        <input type="text" class="form-control" v-model="submittedBy"
                                            name="submitted-by" id="submitted-by" placeholder="Submitted By"
                                            :disabled="true">
                                        <span class="field-error" v-if="submittedByErrMsg">{{
                                            submittedByErrMsg }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-around mt-4 mb-3">
                                <button type="button" @click="validateFields()" class="btn-lg btn-primary"
                                    style="width: 150px;">Save
                                </button>
                                <button type="button" @click="closeModal()" class="btn-lg btn-primary"
                                    style="width: 150px;">Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <audit-log-popup :logs="logs" :popUpTitle="popUpTitle"></audit-log-popup>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import EventBus from "./event-bus";
import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
Vue.use(VueGoodTable);

import { commonMixins } from '../mixins/commonMixins';
import { dataTableMixins } from '../mixins/dataTableMixins';
import { contractMixins } from '../mixins/contractMixins';
import moment from "moment";

import AuditLogPopUp from "./AuditLogPopUp.vue";
Vue.component("audit-log-popup", AuditLogPopUp);

export default {
    name: "CreditMemoLog",
    components: {
        customPagination: () => import('@/components/layout/CustomPagination'),
        dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
        clearCacheData: () => import('@/components/ClearCacheData'),
        appFooter: () => import('@/components/Footer'),
    },
    mixins: [commonMixins, dataTableMixins, contractMixins],
    metaInfo() {
        return { title: "Credit Memo Log | " + process.env.COPYRIGHT_NAME }
    },
    data: () => ({
        permissions: [],
        cantAccessPage: '',
        userColumns: [],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
                filterable: false,
                hidden: true,
                width: '100px'
            },
            {
                label: 'Dealer Code',
                field: 'dealer_code',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Dealer Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Dealer Name',
                field: 'dealer_name',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Dealer Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'BillCusID',
                field: 'bill_cus_id',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "BillCusID", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'CM#',
                field: 'cm_number',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "CM#", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'CM Date',
                field: 'cm_date',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "CM Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'CM $ Grand Total',
                field: 'cm_grand_total',
                fpFieldType: "integer",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "CM $ Grand Total", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Issued By',
                field: 'issued_by',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Issued By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Submitted to Accounting',
                field: 'submitted_to_accounting',
                fpFieldType: "option",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Submitted to Accounting", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                    filterDropdownItems: ["Yes", "No"],
                },
            },
            {
                label: 'Submitted Date',
                field: 'submitted_date',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Submitted Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Submitted By',
                field: 'submitted_by',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Submitted By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
        ],
        rows: [],
        totalRecords: 0,
        loading: false,
        canEditCreditMemoLog: false,
        pageKey: "_credit_memo_log",
        errorMsg: "",
        editId: 0,
        submittedToAccounting: "",
        submittedToAccountingErrMsg: '',
        submittedDate: "",
        submittedDateErrMsg: '',
        submittedBy: "",
        submittedByErrMsg: '',
        dateOptions: {
            format: 'MM/DD/YYYY',
            useCurrent: false
        },
        logoPath: '',
        userObj: {},
        canViewAuditLog: false,
        logs: [],
        popUpTitle: "Credit Memo Activity Log Details",
        canExport: false,
        firstLoad: 0,
        action: 'list',
        batchProcess: 0,
        batchNum: ''
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ev_claim_credit_memo_log') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'ev_claim_edit_credit_memo_log') {
                        self.canEditCreditMemoLog = true;
                    }
                    if (permissions[i].name == 'ev_claim_view_credit_memo_audit_log') {
                        self.canViewAuditLog = true;
                    }
                    if (permissions[i].name == 'ev_claim_export_credit_memo_log') {
                        self.canExport = true;
                    }
                }
            }
            if (self.canEditCreditMemoLog || self.canViewAuditLog) {
                self.handleColumnVisibility();
            }
        },
    },
    created: function () {
        this.logoPath = process.env.LOGO_PATH;
    },
    mounted: function () {
        var self = this;
        self.getPermissions();
        self.userObj = JSON.parse(localStorage.getItem("user_obj"));
    },
    methods: {
        cancelAll: function () {
            this.$refs.creditMemoLogList.unselectAllInternal();
        },
        handleColumnVisibility() {
            this.columns.forEach((column) => {
                if (
                    column.field == 'action'
                ) {
                    column.hidden = false;
                }
            });
        },
        loadList() {
            var self = this;
            self.loading = true;

            var selectedRows = [];
            if (self.firstLoad == 1) {
                //because on first load list not initialize
                var data = this.$refs['creditMemoLogList'].selectedRows;
                if (data.length > 0) {
                    for (var i = 0; i < data.length; i++) {
                        selectedRows.push(this.$refs['creditMemoLogList'].selectedRows[i].id)
                    }
                }
            }

            self.firstLoad = 1;
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                selectedRows: selectedRows,
                action: self.action,
                selectedAll: self.serverParams.selectedAll
            };
            $.ajax({
                url: process.env.ROOT_API + "/warranty-claim/credit-memo-log",
                type: "GET",
                data: fields,
                headers: self.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        if (self.action == "export" || self.action == "export_queue") {
                            if (data.code == "201") {
                                alert(data.message);
                            } else {
                                if (self.action == "export") {
                                    var save = document.createElement("a");
                                    save.href = data.content;
                                    save.download = data.content;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);
                                } else {
                                    self.batchProcess = 1;
                                    self.batchNum = data.content;
                                }
                            }
                            self.action = "list";
                        } else {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'credit-memo-list');
                }
            });
        },
        showEditModal(row) {
            this.editId = row.id;
            this.submittedToAccounting = row.submitted_to_accounting || '';
            this.submittedBy = row.submitted_by || (this.userObj.username || this.userObj.email);
            this.submittedDate = row.submitted_date || moment().format('MM/DD/YYYY');

            $('#editCreditMemoLog').modal('show');
        },
        closeModal() {
            this.clearErrFields();
            this.editId = 0;
            this.submittedToAccounting = '';
            this.submittedDate = '';
            this.submittedBy = '';

            $('#editCreditMemoLog').modal('hide');
        },
        validateFields() {
            var success = true;
            this.clearErrFields();

            if (this.submittedToAccounting == '' || this.submittedToAccounting == null) {
                this.submittedToAccountingErrMsg = 'Submitted to Accounting is required';
                success = false;
            }
            if (this.submittedDate == '' || this.submittedDate == null) {
                this.submittedDateErrMsg = 'Submitted Date is required';
                success = false;
            }
            if (this.submittedBy == '' || this.submittedBy == null) {
                this.submittedByErrMsg = 'Submitted By is required';
                success = false;
            }

            if (success) {
                this.saveCreditMemoLogFields();
            } else {
                this.errorValidationFocus();
            }
        },
        saveCreditMemoLogFields() {
            var self = this;
            self.loading = true;

            let formData = new FormData();
            formData.append('id', self.editId);
            formData.append('submitted_to_accounting', self.submittedToAccounting);
            formData.append('submitted_date', self.submittedDate);
            formData.append('submitted_by', self.userObj.id);

            $.ajax({
                url: process.env.ROOT_API + "/warranty-claim/update-credit-memo-log-fields",
                type: "POST",
                data: formData,
                processData: false,
                contentType: false,
                headers: this.ajxHeaders,
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.$swal({
                            title: "",
                            text: "Credit Memo Log Updated Successfully.",
                            type: "success",
                            showCancelButton: false,
                            confirmButtonText: "Okay",
                            showCloseButton: false,
                        }).then(result => {
                            self.closeModal();
                            self.loadList();
                        });
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'save-backorder-fields');
                }
            });
        },
        clearErrFields() {
            this.submittedByErrMsg = '';
            this.submittedDateErrMsg = '';
            this.submittedToAccountingErrMsg = '';
        },
        submittedToAccountingChanged(value) {
            if (value == '' || value == null) {
                this.submittedToAccounting = '';
            }
        },
        goToGetDocumentPath(event, row) {
            event.preventDefault();
            var self = this;
            var path = row.credit_memo_pdf_path;
            var id = 0;

            self.getDocumentPath(id, path, '');
        },
        goToGetLogInfo(logId) {
            var self = this;
            var logFlag = 'CREDIT_MEMO_LOG';
            self.getLogInfo(logId, logFlag);
        },
        exportCheck: function () {
            var count = 0;
            var actionFlag = "";
            var data = this.$refs['creditMemoLogList'].selectedRows;
            count = data.length;

            if (this.serverParams.selectedAll == true) {
                actionFlag = "";
            } else if (count != 0 && count <= 100) {
                actionFlag = "export";
            }

            this.exportReports(actionFlag);
        },
    }
};
</script>
<style scoped>
.data-table table.vgt-table .fp-log-file-format {
    font-size: 15px;
}

.loader-vvg {
    z-index: 1063;
}
</style>



// WEBPACK FOOTER //
// src/components/CreditMemoLog.vue